import { render } from "./NotificationTopicModal.vue?vue&type=template&id=ccc1a216"
import script from "./NotificationTopicModal.vue?vue&type=script&lang=js"
export * from "./NotificationTopicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__